import { ProductType } from '../types';
import { Breadcrumb, BreadCrumbInput } from '../types/breadcrumbs';

export class BreadcrumbsService {
    static generateBreadcrumbs(
        input: BreadCrumbInput[],
        productType: ProductType,
    ): Breadcrumb[] {
        return input.reduce<Breadcrumb[]>((result, item) => {
            switch (item.type) {
                case 'universe':
                    return result.concat({
                        name: item.value.name,
                        url: item.value.url_path,
                    });

                case 'productType':
                    return result.concat({
                        name: item.value.name,
                        url: item.value.url_path,
                    });

                case 'expansion':
                    if (!item.value) return result;
                    return result.concat({
                        name: item.value.name,
                        url: `${productType.url_path}/${item.value.slug}`,
                    });

                case 'product':
                    return result.concat({
                        name: item.value.name,
                        url: '',
                    });

                default:
                    return result;
            }
        }, []);
    }
}
